var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarTrainIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19.9986,
    height: 19.9986,
    rx: 9.99931,
    fill: "#FFF9EF"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99931 0C4.47684 0 0 4.47684 0 9.99931C0 10.1332 0.00263315 10.2666 0.0078505 10.3992C0.217762 5.06213 4.61078 0.799805 9.99931 0.799805C15.3878 0.799805 19.7809 5.06213 19.9908 10.3992C19.996 10.2666 19.9986 10.1332 19.9986 9.99931C19.9986 4.47684 15.5218 0 9.99931 0Z",
    fill: "white",
    fillOpacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99996 19.9985C15.5224 19.9985 19.9993 15.5217 19.9993 9.99923C19.9993 9.86529 19.9966 9.73198 19.9914 9.59932C19.7815 14.9364 15.3885 19.1987 9.99996 19.1987C4.61143 19.1987 0.218413 14.9364 0.00850196 9.59932C0.00328535 9.73198 0.000651292 9.86529 0.00065128 9.99922C0.000650797 15.5217 4.47749 19.9985 9.99996 19.9985Z",
    fill: "#030303",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33339 12.2222H3.77783V14H7.33339V12.2222Z",
    fill: "#505050"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7778 14.8889C4.26872 14.8889 4.66669 14.4909 4.66669 14C4.66669 13.5091 4.26872 13.1111 3.7778 13.1111C3.28689 13.1111 2.88892 13.5091 2.88892 14C2.88892 14.4909 3.28689 14.8889 3.7778 14.8889Z",
    fill: "#646464"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7777 14.4444C4.02316 14.4444 4.22214 14.2454 4.22214 14C4.22214 13.7545 4.02316 13.5555 3.7777 13.5555C3.53224 13.5555 3.33325 13.7545 3.33325 14C3.33325 14.2454 3.53224 14.4444 3.7777 14.4444Z",
    fill: "#494949"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33322 14.8889C7.82414 14.8889 8.22211 14.4909 8.22211 14C8.22211 13.5091 7.82414 13.1111 7.33322 13.1111C6.84231 13.1111 6.44434 13.5091 6.44434 14C6.44434 14.4909 6.84231 14.8889 7.33322 14.8889Z",
    fill: "#646464"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33336 14.4444C7.57882 14.4444 7.7778 14.2454 7.7778 14C7.7778 13.7545 7.57882 13.5555 7.33336 13.5555C7.0879 13.5555 6.88892 13.7545 6.88892 14C6.88892 14.2454 7.0879 14.4444 7.33336 14.4444Z",
    fill: "#494949"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2223 12.2222H12.6667V14H16.2223V12.2222Z",
    fill: "#505050"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 14.8889C13.1576 14.8889 13.5556 14.4909 13.5556 14C13.5556 13.5091 13.1576 13.1111 12.6667 13.1111C12.1758 13.1111 11.7778 13.5091 11.7778 14C11.7778 14.4909 12.1758 14.8889 12.6667 14.8889Z",
    fill: "#646464"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6666 14.4444C12.9121 14.4444 13.1111 14.2454 13.1111 14C13.1111 13.7545 12.9121 13.5555 12.6666 13.5555C12.4212 13.5555 12.2222 13.7545 12.2222 14C12.2222 14.2454 12.4212 14.4444 12.6666 14.4444Z",
    fill: "#494949"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2221 14.8889C16.7131 14.8889 17.111 14.4909 17.111 14C17.111 13.5091 16.7131 13.1111 16.2221 13.1111C15.7312 13.1111 15.3333 13.5091 15.3333 14C15.3333 14.4909 15.7312 14.8889 16.2221 14.8889Z",
    fill: "#646464"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2223 14.4444C16.4677 14.4444 16.6667 14.2454 16.6667 14C16.6667 13.7545 16.4677 13.5555 16.2223 13.5555C15.9768 13.5555 15.7778 13.7545 15.7778 14C15.7778 14.2454 15.9768 14.4444 16.2223 14.4444Z",
    fill: "#494949"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1111 6H2.88892V13.1111H17.1111V6Z",
    fill: "#00783C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12.2222H2V13.1111H18V12.2222Z",
    fill: "#008C46"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18 6.88889H2V7.77777H18V6.88889Z",
    fill: "#008C46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarTrainIcon);
export default __webpack_public_path__ + "static/media/car_train_icon.3f94d456eebd34e7dcc77f266badbdff.svg";
export { ForwardRef as ReactComponent };